import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Add global error handler
window.addEventListener('error', (event) => {
  console.error('❌ Global error:', event.error);
  console.error('Error details:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
  event.preventDefault();
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('❌ Unhandled promise rejection:', event.reason);
  event.preventDefault();
});

try {
  const root = document.getElementById("root");
  if (!root) {
    throw new Error('Root element not found');
  }

  createRoot(root).render(<App />);
} catch (error) {
  console.error('❌ Failed to initialize app:', error);
}

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
